import { useEffect, useState } from "react";
import { Slider } from "react-semantic-ui-range";
import {
  Button,
  Checkbox,
  Divider,
  Dropdown,
  Form,
  Icon,
  List
} from "semantic-ui-react";
import * as THREE from "three";
import { getBase64, getCanvas } from "../util/File";
import AccordionItem from "./AccordionItem";
import ColorPicker from "./ColorPicker";

function MaterialAccordionItem( { material, index } ) {
  const [refreshCount, setRefrecsCount] = useState( 0 );
  const [imageSaveOption, setImageSaveOption] = useState( "jpg" );
  const [offsetX, setOffsetX] = useState( 0 );
  const [offsetY, setOffsetY] = useState( 0 );
  const [currentMaterial, setCurrentMaterial] = useState( material );

  useEffect( () => { }, [] );

  const loader = new THREE.TextureLoader();

  const imageSaveOptions = [
    { key: "png", text: "PNG", value: "png" },
    { key: "jpg", text: "JPG", value: "jpg" },
  ];
const loadAllFiles = () => {
  const textureEntries = [
    { type: "diffuse", map: currentMaterial.map },
    { type: "ao", map: currentMaterial.aoMap },
    { type: "normal", map: currentMaterial.normalMap },
    { type: "metalness", map: currentMaterial.metalnessMap },
    { type: "roughness", map: currentMaterial.roughnessMap },
    { type: "emissive", map: currentMaterial.emissiveMap },
    { type: "alpha", map: currentMaterial.alphaMap },
  ];

  textureEntries.forEach(({ type, map }) => {
    if (map) {
      loadFile(type, map);
    }
  });
};


  
  const loadFile = async ( name, map ) => {
    if ( !map ) return;
    const canvas = getCanvas();
    const context = canvas.getContext( "2d" );

    canvas.width = map.image.width;
    canvas.height = map.image.height;
    context.drawImage( map.image, 0, 0, map.image.width, map.image.height );

    const link = document.createElement( "a" );
    link.href = canvas.toDataURL(
      imageSaveOption === "jpg" ? "image/jpeg" : "image/png"
    );
    link.download = currentMaterial.name + "_" + name + "_" + map.name;
    link.click();
  };

  const updateSceneMaterial = async () => {
    setRefrecsCount( refreshCount + 1 );
  };

  const changeDiffuseMap = async ( file ) => {
    var f = await getBase64( file );
    var r = await loader.loadAsync( f );

    let tmpMap = currentMaterial.map;
    currentMaterial.map = r;
    currentMaterial.map.encoding = THREE.sRGBEncoding;
    if ( tmpMap ) {
      currentMaterial.map.repeat = tmpMap.repeat;
      currentMaterial.map.flipY = tmpMap.flipY;
      currentMaterial.map.wrapS = THREE.RepeatWrapping;
      currentMaterial.map.wrapT = THREE.RepeatWrapping;
      currentMaterial.map.needsUpdate = true;
    }
    currentMaterial.needsUpdate = true;

    updateSceneMaterial();
  };

  const changeNormallMap = async ( file ) => {
    var f = await getBase64( file );
    var r = await loader.loadAsync( f );

    let tmpMap = currentMaterial.normalMap;
    currentMaterial.normalMap = r;
    if ( tmpMap ) {
      currentMaterial.normalMap.repeat = tmpMap.repeat;
      currentMaterial.normalMap.wrapS = THREE.RepeatWrapping;
      currentMaterial.normalMap.wrapT = THREE.RepeatWrapping;
      currentMaterial.normalMap.flipY = tmpMap.flipY;
      currentMaterial.normalMap.needsUpdate = true;
      console.log( "normalmap.repeat", tmpMap.repeat );
    }
    currentMaterial.needsUpdate = true;

    updateSceneMaterial();
  };

  const changeColor = async ( colorHex ) => {
    console.log( colorHex )
    currentMaterial.color = new THREE.Color( colorHex ).convertSRGBToLinear();
  };

  const changeSheenColor = async ( colorHex ) => {
    currentMaterial.sheen = new THREE.Color( colorHex ).convertSRGBToLinear();
    currentMaterial.needsUpdate = true;
    updateSceneMaterial();
  };

  function getModelViewer() {
    return document.getElementsByTagName( "sugar-model-viewer" )[0];
  }

  function enableTransmissionMaterial() {
    getModelViewer()?.onMaterialChanged();
  }

  async function getMaterialApplier() {
    return getModelViewer()?.materialManager.getMaterialApplier();
  }

  const [transmissedMaterials, setTransmissedMaterials] = useState( [] );

  const changeParam = async ( paramName, paramValue ) => {
    currentMaterial[paramName] = paramValue;
    if ( currentMaterial.type !== "MeshPhysicalMaterial" ) {
      enableTransmissionMaterial();
      const materialApplier = await getMaterialApplier();
      const convertedMaterial = materialApplier.convertPhysicalMaterialAndApply( currentMaterial );
      setCurrentMaterial( convertedMaterial );
    }
    currentMaterial.needsUpdate = true;
    updateSceneMaterial();
    document.dispatchEvent( new CustomEvent( "update-transmission-parameter", {
      detail: {
        name: currentMaterial.name,
        [paramName]: currentMaterial[paramName],
      }
    } ) );
  }

  const changeEmissiveColor = async ( colorHex ) => {
    currentMaterial.emissive = new THREE.Color( colorHex ).convertSRGBToLinear();
  };

  const changeOpacityMap = async ( file ) => {
    let f = await getBase64( file );
    let r = await loader.loadAsync( f );

    currentMaterial.alphaMap = r;
    currentMaterial.transparent = true;
    currentMaterial.alphaTest = 0.0;
    currentMaterial.depthWrite = true;
    currentMaterial.needsUpdate = true;

    updateSceneMaterial();
  };

  const changeAoMap = async ( file ) => {
    let f = await getBase64( file );
    let r = await loader.loadAsync( f );

    currentMaterial.aoMap = r;
    //currentMaterial.aoMap.flipY = true;
    currentMaterial.needsUpdate = true;

    updateSceneMaterial();
  };

  const changeRougnessMap = async ( file ) => {
    let f = await getBase64( file );
    let r = await loader.loadAsync( f );

    currentMaterial.roughnessMap = r;
    //currentMaterial.roughnessMap.flipY = true;
    currentMaterial.needsUpdate = true;

    updateSceneMaterial();
  };

  const changeMetallnessMap = async ( file ) => {
    let f = await getBase64( file );
    let r = await loader.loadAsync( f );

    currentMaterial.metalnessMap = r;
    //currentMaterial.metalnessMap.flipY = true;
    currentMaterial.needsUpdate = true;

    updateSceneMaterial();
  };

  const changeEmissiveMap = async ( file ) => {
    let f = await getBase64( file );
    let r = await loader.loadAsync( f );

    currentMaterial.emissiveMap = r;
    //currentMaterial.metalnessMap.flipY = true;
    currentMaterial.needsUpdate = true;

    updateSceneMaterial();
  };

  const changeMaterialMetallness = async ( metalnessValue ) => {
    //setMetalnessValue(metalnessValue);
    currentMaterial.metalness = metalnessValue;
    updateSceneMaterial();
  };

  const changeMaterialRoughness = async ( roughnessValue ) => {
    //setRoughnessValue(roughnessValue);
    currentMaterial.roughness = roughnessValue;
    updateSceneMaterial();
  };

  const changeEmissiveIntensity = async ( emissiveValue ) => {
    currentMaterial.emissiveIntensity = emissiveValue;
    updateSceneMaterial();
  };

  const changeOpacity = async ( opacityValue ) => {
    currentMaterial.opacity = opacityValue;
    currentMaterial.needsUpdate = true;
    updateSceneMaterial();
  };

  const changeAlphaTest = async ( value ) => {
    currentMaterial.alphaTest = value;
    updateSceneMaterial();
  };

  const changeOffsetX = async ( value, map ) => {
    setOffsetX( value );
    if ( map ) map.offset = new THREE.Vector2( offsetX, offsetY );
    updateSceneMaterial();
  };

  const changeOffsetY = async ( value, map ) => {
    setOffsetY( value );
    if ( map ) map.offset = new THREE.Vector2( offsetX, offsetY );
    updateSceneMaterial();
  };

  const toggleTransparent = async () => {
    currentMaterial.transparent = !currentMaterial.transparent;
    updateSceneMaterial();
  };

  const toggleSide = async () => {
    currentMaterial.side = currentMaterial.side === THREE.FrontSide ? THREE.DoubleSide : THREE.FrontSide;
    currentMaterial.needsUpdate = true;
    updateSceneMaterial();
  }

  const toggleDepthTest = async () => {
    currentMaterial.depthTest = !currentMaterial.depthTest;
    currentMaterial.needsUpdate = true;
    updateSceneMaterial();
  };

  const toggleDepthWrite = async () => {
    currentMaterial.depthWrite = !currentMaterial.depthWrite;
    currentMaterial.needsUpdate = true;
    updateSceneMaterial();
  };

  const toggleFlipY = async ( mapName ) => {
    const map = currentMaterial[mapName];
    if ( map ) {
      currentMaterial[mapName] = await flipMap( map );
      map.flipped = !map.flipped;
    }

    currentMaterial.needsUpdate = true;
    updateSceneMaterial();
  };

  const toggleFlipX = async ( map ) => {
    if ( map ) {
      map.repeat.x *= -1;
    }
    currentMaterial.needsUpdate = true;
    updateSceneMaterial();
  };

  // const mergeMaps = async (
  //   aoMap,
  //   roughnessMap,
  //   metallicMap,
  //   roughness = 1.0,
  //   metallic = 0.0
  // ) => {
  //   const canvas = getCanvas();
  //   const context = canvas.getContext("2d");

  //   const aoSize = getWidthHeight(aoMap);
  //   const roughnessSize = getWidthHeight(roughnessMap);
  //   const metallicSize = getWidthHeight(metallicMap);

  //   const arraySize = [aoSize, roughnessSize, metallicSize];
  //   arraySize.sort((a, b) => {
  //     return a.width > b.width ? -1 : 1;
  //   });
  //   const size = arraySize[0];

  //   canvas.width = size.width;
  //   canvas.height = size.height;
  //   const aoContextMap = await getContextImage(aoMap, context, size);
  //   const roughnessContextMap = await getContextImage(
  //     roughnessMap,
  //     context,
  //     size
  //   );
  //   const metallicContextMap = await getContextImage(
  //     metallicMap,
  //     context,
  //     size
  //   );

  //   const composite = context.getImageData(0, 0, size.width, size.height);

  //   for (var i = 0; i < size.height; i++) {
  //     for (var j = 0; j < size.width; j++) {
  //       var idx = 4 * (i * size.width + j);
  //       composite.data[idx] = aoContextMap ? aoContextMap.data[idx] : 255.0;
  //       composite.data[idx + 1] = roughnessContextMap
  //         ? roughnessContextMap.data[idx]
  //         : roughness * 255;
  //       composite.data[idx + 2] = metallicContextMap
  //         ? metallicContextMap.data[idx]
  //         : metallic * 255;
  //       composite.data[idx + 3] = 255.0;
  //     }
  //   }

  //   context.putImageData(composite, 0, 0);

  //   const link = document.createElement("a");
  //   link.href = canvas.toDataURL("image/jpeg");
  //   link.download = "orm";
  //   link.click();
  // };

  // const getWidthHeight = (map) => {
  //   if (map == null) return { width: 0, height: 0 };
  //   return {
  //     width: map.image.width,
  //     height: map.image.height,
  //   };
  // };

  // const getContextImage = async (map, context, size) => {
  //   if (map == null) return null;

  //   const mapImage = map?.image;
  //   context.drawImage(
  //     mapImage,
  //     0,
  //     0,
  //     mapImage.width,
  //     mapImage.height,
  //     0,
  //     0,
  //     size.width,
  //     size.height
  //   );
  //   return context.getImageData(0, 0, mapImage.width, mapImage.height);
  // };

  const flipMap = async ( map ) => {
    const mapImage = map?.image;
    const width = Math.max( mapImage?.width || 0, mapImage?.width || 0 );
    const height = Math.max( mapImage?.height || 0, mapImage?.height || 0 );

    const canvas = getCanvas();
    canvas.width = width;
    canvas.height = height;

    const context = canvas.getContext( "2d" );
    context.drawImage( mapImage, 0, 0, width, height );
    const composite = context.getImageData( 0, 0, width, height );
    const composite2 = context.getImageData( 0, 0, width, height );

    for ( var i = 0; i < height; i++ ) {
      for ( var j = 0; j < width; j++ ) {
        composite.data[4 * ( i * width + j ) + 3] =
          composite2.data[4 * ( ( height - i - 1 ) * width + j ) + 3];
        composite.data[4 * ( i * width + j ) + 2] =
          composite2.data[4 * ( ( height - i - 1 ) * width + j ) + 2];
        composite.data[4 * ( i * width + j ) + 1] =
          composite2.data[4 * ( ( height - i - 1 ) * width + j ) + 1];
        composite.data[4 * ( i * width + j ) + 0] =
          composite2.data[4 * ( ( height - i - 1 ) * width + j ) + 0];
      }
    }

    context.putImageData( composite, 0, 0 );
    const texture = map.clone();

    texture.image = canvas;
    texture.needsUpdate = true;
    texture.encoding = THREE.sRGBEncoding;
    texture.format = THREE.RGBAFormat;
    texture.userData = texture.userData ? texture.userData : {};
    //texture.userData.mimeType = 'image/png';
    return texture;
  };

  const getBitmapCanvas = ( e ) => {
    if ( !e || !e.image ) return;
    if ( e?.image?.src ) {
      return e.image.src;
    }

    //for upload from outsideg
    //create icon
    const canvas = getCanvas();
    canvas.width = 128;
    canvas.height = 128;
    const context = canvas.getContext( "2d" );
    if ( e.image.depth ) {
      return;
    }
    context.drawImage( e.image, 0, 0, canvas.width, canvas.height );
    e.image.src = canvas.toDataURL();

    return e.image.src;
  };

  const handleSaveOptionChange = ( value ) => {
    setImageSaveOption( value );
  };

  return (
    <AccordionItem
      header={currentMaterial?.name + "---" + currentMaterial?.uuid.substr( 0, 8 )}
      on={currentMaterial?.accordionItemOn || false}
      onActive={( act ) => {
        currentMaterial.accordionItemOn = act;
      }}
    >
      <span>Type: {currentMaterial?.type}</span>
      {/*    */}
      <List.Item>
        <div className="row">
          <div className="column materialNameColumn">
            <label className="materialName">Base Color: </label>
          </div>

          <div className="column">
            <ColorPicker
              color={
                currentMaterial.color
                  ? "#" + currentMaterial.color.getHexString( "SRGBColorSpace" )
                  : "#FFFFFF"
              }
              onChangeColor={( e ) => {
                changeColor( e );
              }}
            />
          </div>
        </div>
      </List.Item>

      <Divider />

      {/* Sheen Color */}
      <List.Item>
        <div className="row">
          <div className="column materialNameColumn">
            <label className="materialName">Sheen Color: </label>
          </div>

          <div className="column">
            <ColorPicker
              color={
                currentMaterial.sheen
                  ? "#" + currentMaterial.sheen.getHexString( "SRGBColorSpace" )
                  : "#000000"
              }
              onChangeColor={( e ) => {
                changeSheenColor( e );
              }}
            />
          </div>
        </div>
      </List.Item>

      <Divider />

      {/* Ao Map */}
      <List.Item>
        <div className="row">
          <div className="column materialNameColumn">
            <label className="materialName">Ao Map: </label>
          </div>

          <div className="column">
            <div className="row">
              <div className="column">
                <div className="row">
                  <div className="column">
                    <img
                      avatar
                      src={getBitmapCanvas( currentMaterial.aoMap )}
                      className="materialImage"
                    />
                  </div>
                  <div className="column">
                    <div className="row">
                      <button key={index} className="sceneMaterialButton">
                        <label htmlFor={"uploadAoMap" + index}>
                          <Icon name="upload" />{" "}
                        </label>
                        <input
                          type="file"
                          hidden
                          id={"uploadAoMap" + index}
                          onChange={( e ) => {
                            changeAoMap( e.target.files[0] );
                          }}
                        />
                      </button>
                    </div>
                    <div className="row">
                      <div className="row">
                        <div className="column">
                          <button
                            className="sceneMaterialButton"
                            onClick={() => {
                              currentMaterial.aoMap = null;
                              currentMaterial.needsUpdate = true;
                              updateSceneMaterial();
                            }}
                          >
                            <Icon name="delete" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="column">
                <div className="row">
                  <div className="column">
                    <div className="row">FlipY</div>
                    <div className="row">
                      <Checkbox
                        toggle
                        checked={currentMaterial.aoMap?.flipped}
                        onChange={( e ) => toggleFlipY( "aoMap" )}
                      />
                    </div>
                    <div className="column">
                      <div className="row">FlipX</div>
                      <div className="row">
                        <Checkbox
                          toggle
                          checked={currentMaterial.aoMap?.repeat?.x < 0 || false}
                          onChange={( e ) =>
                            toggleFlipX( currentMaterial.aoMap )
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <div className="column">
                    <Button.Group>
                      <Button
                        style={{ width: "5px" }}
                        onClick={( e ) => {
                          loadFile( "occlusion", currentMaterial.aoMap );
                        }}
                      >
                        <Icon name="download" />
                      </Button>
                      <Dropdown
                        style={{ width: "5px" }}
                        className="button"
                        floating
                        options={imageSaveOptions}
                        trigger={<></>}
                        onChange={( e, o ) => handleSaveOptionChange( o.value )}
                        value={imageSaveOption}
                      />
                    </Button.Group>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </List.Item>

      <Divider />

      {/* Diffuse Map */}
      <List.Item>
        <div className="row">
          <div className="column materialNameColumn">
            <label className="materialName">Diffuse Map: </label>
          </div>

          <div className="column">
            <div className="row">
              <div className="column">
                <div className="row">
                  <div className="column">
                    <img
                      avatar
                      src={getBitmapCanvas( currentMaterial.map )}
                      className="materialImage"
                    />
                  </div>
                  <div className="column">
                    <div className="row">
                      <button key={index} className="sceneMaterialButton">
                        <label htmlFor={"uploadMap" + index}>
                          <Icon name="upload" />{" "}
                        </label>
                        <input
                          type="file"
                          hidden
                          id={"uploadMap" + index}
                          onChange={( e ) => {
                            changeDiffuseMap( e.target.files[0] );
                          }}
                        />
                      </button>
                    </div>
                    <div className="row">
                      <div className="row">
                        <div className="column">
                          <button
                            className="sceneMaterialButton"
                            onClick={() => {
                              currentMaterial.map = null;
                              currentMaterial.needsUpdate = true;
                              updateSceneMaterial();
                            }}
                          >
                            <Icon name="delete" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="column">
                <div className="row">
                  <div className="column">
                    <div className="row">FlipY</div>
                    <div className="row">
                      <Checkbox
                        toggle
                        checked={currentMaterial.map?.flipped}
                        onChange={( e ) => toggleFlipY( "map" )}
                      />
                    </div>
                    <div className="column">
                      <div className="row">FlipX</div>
                      <div className="row">
                        <Checkbox
                          toggle
                          checked={currentMaterial.map?.repeat?.x < 0 || false}
                          onChange={( e ) => toggleFlipX( currentMaterial.map )}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="column">
                    <Button.Group>
                      <Button
                        style={{ width: "5px" }}
                        onClick={( e ) => {
                          loadFile( "diffuse", currentMaterial.map );
                        }}
                      >
                        <Icon name="download" />
                      </Button>
                      <Dropdown
                        style={{ width: "5px" }}
                        className="button"
                        floating
                        options={imageSaveOptions}
                        trigger={<></>}
                        onChange={( e, o ) => handleSaveOptionChange( o.value )}
                        value={imageSaveOption}
                      />
                    </Button.Group>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </List.Item>

      <Divider />

      {/* Normal Map */}
      <List.Item>
        <div className="row">
          <div className="column materialNameColumn">
            <label className="materialName">Normal Map: </label>
          </div>

          <div className="column">
            <div className="row">
              <div className="column">
                <div className="row">
                  <div className="column">
                    <img
                      avatar
                      src={getBitmapCanvas( currentMaterial.normalMap )}
                      className="materialImage"
                    />
                  </div>
                  <div className="column">
                    <div className="row">
                      <button key={index} className="sceneMaterialButton">
                        <label htmlFor={"uploadNormalMap" + index}>
                          <Icon name="upload" />{" "}
                        </label>
                        <input
                          type="file"
                          hidden
                          id={"uploadNormalMap" + index}
                          onChange={( e ) => {
                            changeNormallMap( e.target.files[0] );
                          }}
                        />
                      </button>
                    </div>
                    <div className="row">
                      <div className="row">
                        <div className="column">
                          <button
                            className="sceneMaterialButton"
                            onClick={() => {
                              currentMaterial.normalMap = null;
                              currentMaterial.needsUpdate = true;
                              updateSceneMaterial();
                            }}
                          >
                            <Icon name="delete" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="column">
                <div className="row">
                  <div className="column">
                    <div className="row">FlipY</div>
                    <div className="row">
                      <Checkbox
                        toggle
                        checked={currentMaterial.normalMap?.flipped}
                        onChange={( e ) => toggleFlipY( "normalMap" )}
                      />
                    </div>
                    <div className="column">
                      <div className="row">FlipX</div>
                      <div className="row">
                        <Checkbox
                          toggle
                          checked={currentMaterial.normalMap?.repeat?.x < 0 || false}
                          onChange={( e ) =>
                            toggleFlipX( currentMaterial.normalMap )
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <div className="column">
                    <Button.Group>
                      <Button
                        style={{ width: "5px" }}
                        onClick={( e ) => {
                          loadFile( "normal", currentMaterial.normalMap );
                        }}
                      >
                        <Icon name="download" />
                      </Button>
                      <Dropdown
                        style={{ width: "5px" }}
                        className="button"
                        floating
                        options={imageSaveOptions}
                        trigger={<></>}
                        onChange={( e, o ) => handleSaveOptionChange( o.value )}
                        value={imageSaveOption}
                      />
                    </Button.Group>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </List.Item>

      <Divider />

      {/* Metalness Map */}
      <List.Item>
        <div className="row">
          <div className="column materialNameColumn">
            <label className="materialName">Metalness Map: </label>
          </div>
          <div className="column">
            <div className="row">
              <div className="column">
                <div className="row">
                  <div className="column">
                    <img
                      avatar
                      src={getBitmapCanvas( currentMaterial.metalnessMap )}
                      className="materialImage"
                    />
                  </div>
                  <div className="column">
                    <div className="row">
                      <button key={index} className="sceneMaterialButton">
                        <label htmlFor={"uploadMetalnessMap" + index}>
                          <Icon name="upload" />{" "}
                        </label>
                        <input
                          type="file"
                          hidden
                          id={"uploadMetalnessMap" + index}
                          onChange={( e ) => {
                            changeMetallnessMap( e.target.files[0] );
                          }}
                        />
                      </button>
                    </div>
                    <div className="row">
                      <div className="row">
                        <div className="column">
                          <button
                            className="sceneMaterialButton"
                            onClick={() => {
                              currentMaterial.metalnessMap = null;
                              currentMaterial.needsUpdate = true;
                              updateSceneMaterial();
                            }}
                          >
                            <Icon name="delete" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="column">
                <div className="row">
                  <div className="column">
                    <div className="row">FlipY</div>
                    <div className="row">
                      <Checkbox
                        toggle
                        checked={currentMaterial.metalnessMap?.flipped}
                        onChange={( e ) => toggleFlipY( "metallnessMap" )}
                      />
                    </div>
                    <div className="column">
                      <div className="row">FlipX</div>
                      <div className="row">
                        <Checkbox
                          toggle
                          checked={
                            currentMaterial.metalnessMap?.repeat?.x < 0 || false
                          }
                          onChange={( e ) =>
                            toggleFlipX( currentMaterial.metalnessMap )
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <div className="column">
                    <Button.Group>
                      <Button
                        style={{ width: "5px" }}
                        onClick={( e ) => {
                          loadFile(
                            currentMaterial,
                            "metalnessMap",
                            currentMaterial.metalnessMap
                          );
                        }}
                      >
                        <Icon name="download" />
                      </Button>
                      <Dropdown
                        style={{ width: "5px" }}
                        className="button"
                        floating
                        options={imageSaveOptions}
                        trigger={<></>}
                        onChange={( e, o ) => handleSaveOptionChange( o.value )}
                        value={imageSaveOption}
                      />
                    </Button.Group>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <Form.Group style={{ marginTop: 10, padding: 2 }}>
                <Slider
                  color="blue"
                  style={{
                    trackFill: { backgroundColor: "#3498db" },
                  }}
                  inverted={false}
                  value={currentMaterial.metalness}
                  settings={{
                    max: 1,
                    step: 0.01,
                    min: 0,
                    onChange: ( value ) => {
                      changeMaterialMetallness( value, currentMaterial );
                    },
                  }}
                />

                <Form.Input
                  value={currentMaterial.metalness}
                  size="mini"
                  widths="1"
                  onChange={( e ) => {
                    changeMaterialMetallness( e?.target?.value, currentMaterial );
                  }}
                />
              </Form.Group>
            </div>
          </div>
        </div>
      </List.Item>

      <Divider />

      {/* Roughness Map */}
      <List.Item>
        <div className="row">
          <div className="column materialNameColumn">
            <label className="materialName">Roughness Map: </label>
          </div>
          <div className="column">
            <div className="row">
              <div className="column">
                <div className="row">
                  <div className="column">
                    <img
                      avatar
                      src={getBitmapCanvas( currentMaterial.roughnessMap )}
                      className="materialImage"
                    />
                  </div>
                  <div className="column">
                    <div className="row">
                      <button key={index} className="sceneMaterialButton">
                        <label htmlFor={"uploadRoughnessMap" + index}>
                          <Icon name="upload" />{" "}
                        </label>
                        <input
                          type="file"
                          hidden
                          id={"uploadRoughnessMap" + index}
                          onChange={( e ) => {
                            changeRougnessMap( e.target.files[0] );
                          }}
                        />
                      </button>
                    </div>
                    <div className="row">
                      <div className="row">
                        <div className="column">
                          <button
                            className="sceneMaterialButton"
                            onClick={() => {
                              currentMaterial.roughnessMap = null;
                              currentMaterial.needsUpdate = true;
                              updateSceneMaterial();
                            }}
                          >
                            <Icon name="delete" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="column">
                <div className="row">
                  <div className="column">
                    <div className="row">FlipY</div>
                    <div className="row">
                      <Checkbox
                        toggle
                        checked={currentMaterial.roughnessMap?.flipped}
                        onChange={( e ) => toggleFlipY( "roughnessMap" )}
                      />
                    </div>
                    <div className="column">
                      <div className="row">FlipX</div>
                      <div className="row">
                        <Checkbox
                          toggle
                          checked={
                            currentMaterial.roughnessMap?.repeat?.x < 0 || false
                          }
                          onChange={( e ) =>
                            toggleFlipX( currentMaterial.roughnessMap )
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <div className="column">
                    <Button.Group>
                      <Button
                        style={{ width: "5px" }}
                        onClick={( e ) => {
                          loadFile(
                            currentMaterial,
                            "roughnessMap",
                            currentMaterial.roughnessMap
                          );
                        }}
                      >
                        <Icon name="download" />
                      </Button>
                      <Dropdown
                        style={{ width: "5px" }}
                        className="button"
                        floating
                        options={imageSaveOptions}
                        trigger={<></>}
                        onChange={( e, o ) => handleSaveOptionChange( o.value )}
                        value={imageSaveOption}
                      />
                    </Button.Group>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <Form.Group style={{ marginTop: 10, padding: 2 }}>
                <Slider
                  color="blue"
                  style={{
                    trackFill: { backgroundColor: "#3498db" },
                  }}
                  inverted={false}
                  value={currentMaterial.roughness}
                  settings={{
                    max: 1,
                    step: 0.01,
                    min: 0,
                    onChange: ( value ) => {
                      changeMaterialRoughness( value, currentMaterial );
                    },
                  }}
                />

                <Form.Input
                  value={currentMaterial.roughness}
                  size="mini"
                  widths="1"
                  onChange={( e ) => {
                    changeMaterialRoughness( e?.target?.value, currentMaterial );
                  }}
                />
              </Form.Group>
            </div>
          </div>
        </div>
      </List.Item>

      <Divider />

      {/* Emissive Map */}
      <List.Item>
        <div className="row">
          <div className="column materialNameColumn">
            <label className="materialName">Emissive Map: </label>
          </div>
          <div className="column">
            <div className="row">
              <div className="column">
                <div className="row">
                  <div className="column">
                    <img
                      avatar
                      src={getBitmapCanvas( currentMaterial.emissiveMap )}
                      className="materialImage"
                    />
                  </div>
                  <div className="column">
                    <div className="row">
                      <button key={index} className="sceneMaterialButton">
                        <label htmlFor={"uploadEmissiveMap" + index}>
                          <Icon name="upload" />{" "}
                        </label>
                        <input
                          type="file"
                          hidden
                          id={"uploadEmissiveMap" + index}
                          onChange={( e ) => {
                            changeEmissiveMap( e.target.files[0] );
                          }}
                        />
                      </button>
                    </div>
                    <div className="row">
                      <div className="row">
                        <div className="column">
                          <button
                            className="sceneMaterialButton"
                            onClick={() => {
                              currentMaterial.emissiveMap = null;
                              currentMaterial.needsUpdate = true;
                              updateSceneMaterial();
                            }}
                          >
                            <Icon name="delete" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="column">
                <div className="row">
                  <div className="column">
                    <div className="row">FlipY</div>
                    <div className="row">
                      <Checkbox
                        toggle
                        checked={currentMaterial.emissiveMap?.flipped}
                        onChange={( e ) => toggleFlipY( "emissiveMap" )}
                      />
                    </div>
                    <div className="column">
                      <div className="row">FlipX</div>
                      <div className="row">
                        <Checkbox
                          toggle
                          checked={currentMaterial.emissiveMap?.repeat?.x < 0 || false}
                          onChange={( e ) =>
                            toggleFlipX( currentMaterial.emissiveMap )
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <div className="column">
                    <Button.Group>
                      <Button
                        style={{ width: "5px" }}
                        onClick={( e ) => {
                          loadFile(
                            currentMaterial,
                            "emissiveMap",
                            currentMaterial.emissiveMap
                          );
                        }}
                      >
                        <Icon name="download" />
                      </Button>
                      <Dropdown
                        style={{ width: "5px" }}
                        className="button"
                        floating
                        options={imageSaveOptions}
                        trigger={<></>}
                        onChange={( e, o ) => handleSaveOptionChange( o.value )}
                        value={imageSaveOption}
                      />
                    </Button.Group>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <Form.Group style={{ marginTop: 10, padding: 2 }}>
                <Slider
                  color="blue"
                  style={{
                    trackFill: { backgroundColor: "#3498db" },
                  }}
                  inverted={false}
                  value={currentMaterial.emissiveIntensity}
                  settings={{
                    max: 1,
                    step: 0.01,
                    min: 0,
                    onChange: ( value ) => {
                      changeEmissiveIntensity( value, currentMaterial );
                    },
                  }}
                />

                <Form.Input
                  value={currentMaterial.emissiveIntensity}
                  size="mini"
                  widths="1"
                  onChange={( e ) => {
                    changeEmissiveIntensity( e?.target?.value, currentMaterial );
                  }}
                />
              </Form.Group>
            </div>
          </div>
        </div>
      </List.Item>

      <Divider />

      {/* Emissive Color */}
      <List.Item>
        <div className="row">
          <div className="column materialNameColumn">
            <label className="materialName">Emissive Color: </label>
          </div>

          <div className="column">
            <ColorPicker
              color={
                currentMaterial.emissive
                  ? "#" + currentMaterial.emissive.getHexString( "SRGBColorSpace" )
                  : "000000"
              }
              onChangeColor={( e ) => {
                changeEmissiveColor( e );
              }}
            />
          </div>
        </div>
      </List.Item>

      <Divider />

      {/* Opacity Map */}
      <List.Item>
        <div className="row">
          <div className="column materialNameColumn">
            <label className="materialName">Opacity Map: </label>
          </div>
          <div className="column">
            <div className="row">
              <div className="column">
                <div className="row">
                  <div className="column">
                    <img
                      avatar
                      src={getBitmapCanvas( currentMaterial.alphaMap )}
                      className="materialImage"
                    />
                  </div>
                  <div className="column">
                    <div className="row">
                      <button key={index} className="sceneMaterialButton">
                        <label htmlFor={"uploadAlphaMap" + index}>
                          <Icon name="upload" />{" "}
                        </label>
                        <input
                          type="file"
                          hidden
                          id={"uploadAlphaMap" + index}
                          onChange={( e ) => {
                            changeOpacityMap( e.target.files[0] );
                          }}
                        />
                      </button>
                    </div>
                    <div className="row">
                      <div className="row">
                        <div className="column">
                          <button
                            className="sceneMaterialButton"
                            onClick={() => {
                              currentMaterial.alphaMap = null;
                              currentMaterial.needsUpdate = true;
                              updateSceneMaterial();
                            }}
                          >
                            <Icon name="delete" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="column">
                <div className="row">
                  <div className="column">
                    <div className="row">FlipY</div>
                    <div className="row">
                      <Checkbox
                        toggle
                        checked={currentMaterial.alphaMap?.flipped}
                        onChange={( e ) => toggleFlipY( "alphaMap" )}
                      />
                    </div>
                    <div className="column">
                      <div className="row">FlipX</div>
                      <div className="row">
                        <Checkbox
                          toggle
                          checked={currentMaterial.alphaMap?.repeat?.x < 0 || false}
                          onChange={( e ) =>
                            toggleFlipX( currentMaterial.alphaMap )
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <div className="column">
                    <Button.Group>
                      <Button
                        style={{ width: "5px" }}
                        onClick={( e ) => {
                          loadFile( "alphaMap", currentMaterial.alphaMap );
                        }}
                      >
                        <Icon name="download" />
                      </Button>
                      <Dropdown
                        style={{ width: "5px" }}
                        className="button"
                        floating
                        options={imageSaveOptions}
                        trigger={<></>}
                        onChange={( e, o ) => handleSaveOptionChange( o.value )}
                        value={imageSaveOption}
                      />
                    </Button.Group>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <Form.Group style={{ marginTop: 10, padding: 2 }}>
                <Slider
                  color="blue"
                  style={{
                    trackFill: { backgroundColor: "#3498db" },
                  }}
                  inverted={false}
                  value={currentMaterial.opacity}
                  settings={{
                    max: 1,
                    step: 0.01,
                    min: 0,
                    onChange: ( value ) => {
                      changeOpacity( value, currentMaterial );
                    },
                  }}
                />

                <Form.Input
                  value={currentMaterial.opacity}
                  size="mini"
                  widths="1"
                  onChange={( e ) => {
                    changeOpacity( e?.target?.value, currentMaterial );
                  }}
                />
              </Form.Group>
            </div>
          </div>
        </div>
      </List.Item>

      <Divider />

      <AccordionItem
        header={"Transmission Options"}
      >
        {/* Transmission */}
        <List.Item>
          <div className="row">
            <div className="column materialNameColumn">
              <label className="materialName">Transmission:</label>
            </div>

            <div className="column">
              <div className="row">
                <ColorPicker
                  color={
                    currentMaterial.transmissionColor
                      ? "#" + currentMaterial.transmissionColor.getHexString( "SRGBColorSpace" )
                      : "#000000"
                  }
                  onChangeColor={( e ) => changeParam( "transmissionColor", new THREE.Color( e ) )}
                />
              </div>
              <div className="row">
                <Form.Group style={{ marginTop: 10, padding: 2 }}>
                  <Slider
                    className="fields"
                    color="blue"
                    style={{
                      trackFill: { backgroundColor: "#3498db" },
                    }}
                    inverted={false}
                    value={currentMaterial.transmission || 0}
                    settings={{
                      max: 1,
                      step: 0.01,
                      min: 0,
                      onChange: ( value ) => changeParam( "transmission", value ),
                    }}
                  />

                  <Form.Input
                    value={currentMaterial.transmission || 0}
                    size="mini"
                    widths="1"
                    onChange={( e ) => changeParam( "transmission", e?.target?.value )}
                  />
                </Form.Group>
              </div>
            </div>
          </div>
        </List.Item>

        <Divider />

        {/* IOR */}
        <List.Item>
          <div className="row">
            <div className="column materialNameColumn">
              <label className="materialName">IOR:</label>
            </div>
            <div className="column">
              <div className="row">
                <Form.Group style={{ marginTop: 10, padding: 2 }}>
                  <Slider
                    className="fields"
                    color="blue"
                    style={{
                      trackFill: { backgroundColor: "#3498db" },
                    }}
                    inverted={false}
                    value={currentMaterial.ior || 1}
                    settings={{
                      max: 2.3333,
                      step: 0.01,
                      min: 1,
                      onChange: ( value ) => changeParam( "ior", value, currentMaterial ),
                    }}
                  />

                  <Form.Input
                    value={currentMaterial.ior || 1}
                    size="mini"
                    widths="1"
                    onChange={( e ) => changeParam( "ior", e?.target?.value, currentMaterial )}
                  />
                </Form.Group>
              </div>
            </div>
          </div>
        </List.Item>

        <Divider />

        {/* Thickness */}
        <List.Item>
          <div className="row">
            <div className="column materialNameColumn">
              <label className="materialName">Thickness:</label>
            </div>
            <div className="column">
              <div className="row">
                <Form.Group style={{ marginTop: 10, padding: 2 }}>
                  <Slider
                    className="fields"
                    color="blue"
                    style={{
                      trackFill: { backgroundColor: "#3498db" },
                    }}
                    inverted={false}
                    value={currentMaterial.thickness || 1}
                    settings={{
                      min: 0,
                      max: 40,
                      step: 0.01,
                      onChange: ( value ) => changeParam( "thickness", value, currentMaterial ),
                    }}
                  />

                  <Form.Input
                    value={currentMaterial.thickness || 1}
                    size="mini"
                    widths="1"
                    onChange={( e ) => changeParam( "thickness", e?.target?.value, currentMaterial )}
                  />
                </Form.Group>
              </div>
            </div>
          </div>
        </List.Item>

        <Divider />

        {/* Clearcoat */}
        <List.Item>
          <div className="row">
            <div className="column materialNameColumn">
              <label className="materialName">Clearcoat:</label>
            </div>
            <div className="column">
              <div className="row">
                <Form.Group style={{ marginTop: 10, padding: 2 }}>
                  <Slider
                    className="fields"
                    color="blue"
                    style={{
                      trackFill: { backgroundColor: "#3498db" },
                    }}
                    inverted={false}
                    value={currentMaterial.clearcoat || 1}
                    settings={{
                      min: 0,
                      max: 1,
                      step: 0.01,
                      onChange: ( value ) => changeParam( "clearcoat", value, currentMaterial ),
                    }}
                  />

                  <Form.Input
                    value={currentMaterial.clearcoat || 1}
                    size="mini"
                    widths="1"
                    onChange={( e ) => changeParam( "clearcoat", e?.target?.value, currentMaterial )}
                  />
                </Form.Group>
              </div>
            </div>
          </div>
        </List.Item>

        <Divider />

        {/* Clearcoat Roughness */}
        <List.Item>
          <div className="row">
            <div className="column materialNameColumn">
              <label className="materialName">Clearcoat Roughness:</label>
            </div>
            <div className="column">
              <div className="row">
                <Form.Group style={{ marginTop: 10, padding: 2 }}>
                  <Slider
                    className="fields"
                    color="blue"
                    style={{
                      trackFill: { backgroundColor: "#3498db" },
                    }}
                    inverted={false}
                    value={currentMaterial.clearcoatRoughness || 1}
                    settings={{
                      min: 0,
                      max: 1,
                      step: 0.01,
                      onChange: ( value ) => changeParam( "clearcoatRoughness", value, currentMaterial ),
                    }}
                  />

                  <Form.Input
                    value={currentMaterial.clearcoatRoughness || 1}
                    size="mini"
                    widths="1"
                    onChange={( e ) => changeParam( "clearcoatRoughness", e?.target?.value, currentMaterial )}
                  />
                </Form.Group>
              </div>
            </div>
          </div>
        </List.Item>

        <Divider />

        {/* Specular */}
        <List.Item>
          <div className="row">
            <div className="column materialNameColumn">
              <label className="materialName">Specular:</label>
            </div>

            <div className="column">
              <div className="row">
                <ColorPicker
                  color={
                    currentMaterial.specularColor
                      ? "#" + currentMaterial.specularColor.getHexString( "SRGBColorSpace" )
                      : "#000000"
                  }
                  onChangeColor={( e ) => changeParam( "specularColor", new THREE.Color( e ), currentMaterial )}
                />
              </div>
              <div className="row">
                <Form.Group style={{ marginTop: 10, padding: 2 }}>
                  <Slider
                    className="fields"
                    color="blue"
                    style={{
                      trackFill: { backgroundColor: "#3498db" },
                    }}
                    inverted={false}
                    value={currentMaterial.specularIntensity || 0}
                    settings={{
                      min: 0,
                      max: 1,
                      step: 0.01,
                      onChange: ( value ) => changeParam( "specularIntensity", value, currentMaterial ),
                    }}
                  />

                  <Form.Input
                    value={currentMaterial.specularIntensity || 0}
                    size="mini"
                    widths="1"
                    onChange={( e ) => changeParam( "specularIntensity", e?.target?.value, currentMaterial )}
                  />
                </Form.Group>
              </div>
            </div>
          </div>
        </List.Item>

        <Divider />

        {/* Attenuation */}
        <List.Item>
          <div className="row">
            <div className="column materialNameColumn">
              <label className="materialName">Attenuation:</label>
            </div>

            <div className="column">
              <div className="row">
                <ColorPicker
                  color={
                    currentMaterial.attenuationColor
                      ? "#" + currentMaterial.attenuationColor.getHexString( "SRGBColorSpace" )
                      : "#000000"
                  }
                  onChangeColor={( e ) => changeParam( "attenuationColor", new THREE.Color( e ), currentMaterial )}
                />
              </div>
              <div className="row">
                <Form.Group style={{ marginTop: 10, padding: 2 }}>
                  <Slider
                    className="fields"
                    color="blue"
                    style={{
                      trackFill: { backgroundColor: "#3498db" },
                    }}
                    inverted={false}
                    value={currentMaterial.attenuationIntensity || 0}
                    settings={{
                      min: 0,
                      max: 1,
                      step: 0.01,
                      onChange: ( value ) => changeParam( "attenuationIntensity", value, currentMaterial ),
                    }}
                  />

                  <Form.Input
                    value={currentMaterial.attenuationIntensity || 0}
                    size="mini"
                    widths="1"
                    onChange={( e ) => changeParam( "attenuationIntensity", e?.target?.value, currentMaterial )}
                  />
                </Form.Group>
              </div>
            </div>
          </div>
        </List.Item>

        <Divider />

        {/* Fresnel Color */}
        <List.Item>
          <div className="row">
            <div className="column materialNameColumn">
              <label className="materialName">Fresnel Color: </label>
            </div>

            <div className="column">
              <ColorPicker
                color={
                  currentMaterial.fresnelColor
                    ? "#" + currentMaterial.fresnelColor.getHexString( "SRGBColorSpace" )
                    : "000000"
                }
                onChangeColor={( e ) => {
                  changeEmissiveColor( e );
                }}
              />
            </div>
          </div>
        </List.Item>

        <Divider />

        {/* Fresnel Factor */}
        <List.Item>
          <div className="row">
            <div className="column materialNameColumn">
              <label className="materialName">Fresnel Factor:</label>
            </div>

            <div className="column">
              <div className="row">
                <Form.Group style={{ marginTop: 10, padding: 2 }}>
                  <Slider
                    className="fields"
                    color="blue"
                    style={{
                      trackFill: { backgroundColor: "#3498db" },
                    }}
                    inverted={false}
                    value={currentMaterial.fresnelFactor || 0}
                    settings={{
                      min: currentMaterial.fresnelMin || 0,
                      max: currentMaterial.fresnelMax || 10,
                      step: 0.01,
                      onChange: ( value ) => changeParam( "fresnelFactor", value, currentMaterial ),
                    }}
                  />

                  <Form.Input
                    value={currentMaterial.fresnelFactor || 0}
                    size="mini"
                    widths="1"
                    onChange={( e ) => changeParam( "fresnelFactor", e?.target?.value, currentMaterial )}
                  />
                </Form.Group>
              </div>
            </div>
          </div>
        </List.Item>

        <Divider />

        {/* Fresnel Min */}
        <List.Item>
          <div className="row">
            <div className="column materialNameColumn">
              <label className="materialName">Fresnel Min:</label>
            </div>

            <div className="column">
              <div className="row">
                <Form.Group style={{ marginTop: 10, padding: 2 }}>
                  <Slider
                    className="fields"
                    color="blue"
                    style={{
                      trackFill: { backgroundColor: "#3498db" },
                    }}
                    inverted={false}
                    value={currentMaterial.fresnelMin || 0}
                    settings={{
                      min: 0,
                      max: currentMaterial.fresnelMax || 10,
                      step: 0.01,
                      onChange: ( value ) => changeParam( "fresnelMin", value, currentMaterial ),
                    }}
                  />

                  <Form.Input
                    value={currentMaterial.fresnelMin || 0}
                    size="mini"
                    widths="1"
                    onChange={( e ) => changeParam( "fresnelMin", e?.target?.value, currentMaterial )}
                  />
                </Form.Group>
              </div>
            </div>
          </div>
        </List.Item>

        <Divider />

        {/* Fresnel Max */}
        <List.Item>
          <div className="row">
            <div className="column materialNameColumn">
              <label className="materialName">Fresnel Max:</label>
            </div>

            <div className="column">
              <div className="row">
                <Form.Group style={{ marginTop: 10, padding: 2 }}>
                  <Slider
                    className="fields"
                    color="blue"
                    style={{
                      trackFill: { backgroundColor: "#3498db" },
                    }}
                    inverted={false}
                    value={currentMaterial.fresnelMax || 0}
                    settings={{
                      min: currentMaterial.fresnelMin || 0,
                      max: 10,
                      step: 0.01,
                      onChange: ( value ) => changeParam( "fresnelMax", value, currentMaterial ),
                    }}
                  />

                  <Form.Input
                    value={currentMaterial.fresnelMax || 0}
                    size="mini"
                    widths="1"
                    onChange={( e ) => changeParam( "fresnelMax", e?.target?.value, currentMaterial )}
                  />
                </Form.Group>
              </div>
            </div>
          </div>
        </List.Item>
      </AccordionItem>

      <Divider />

      {/* Transparent */}
      <List.Item>
        <div className="row">
          <div className="column materialNameColumn">
            <label className="materialName">Transparent: </label>
          </div>

          <div className="column">
            <Checkbox
              toggle
              checked={!!currentMaterial.transparent}
              onChange={( e ) => toggleTransparent( currentMaterial )}
            />
          </div>
        </div>
      </List.Item>

      <Divider />

      {/* Depth Test */}
      <List.Item>
        <div className="row">
          <div className="column materialNameColumn">
            <label className="materialName">Depht Test: </label>
          </div>

          <div className="column">
            <Checkbox
              toggle
              checked={currentMaterial.depthTest}
              onChange={( e ) => toggleDepthTest( currentMaterial )}
            />
          </div>

        </div>
      </List.Item>

      <Divider />

      {/* Depth Write */}
      <List.Item>
        <div className="row">
          <div className="column materialNameColumn">
            <label className="materialName">Depth Write: </label>
          </div>

          <div className="column">
            <Checkbox
              toggle
              checked={currentMaterial.depthWrite}
              onChange={( e ) => toggleDepthWrite( currentMaterial )}
            />
          </div>
        </div>
      </List.Item>

      <Divider />

      {/* DoubleSide */}
      <List.Item>
        <div className="row">
          <div className="column materialNameColumn">
            <label className="materialName">DoubleSide: </label>
          </div>

          <div className="column">
            <Checkbox
              toggle
              checked={currentMaterial.side === THREE.DoubleSide}
              onChange={( e ) => toggleSide( currentMaterial )}
            />
          </div>

        </div>
      </List.Item>

      <Divider />

      {/* Alpha Cutoff */}
      <List.Item>
        <div className="row">
          <div className="column materialNameColumn">
            <label className="materialName">Alpha Cutoff: </label>
          </div>

          <div className="column" style={{ width: "120px" }}>
            <Slider
              color="blue"
              style={{
                trackFill: { backgroundColor: "#3498db" },
              }}
              inverted={false}
              value={currentMaterial.alphaTest}
              settings={{
                max: 1,
                step: 0.01,
                min: 0,
                onChange: ( value ) => {
                  changeAlphaTest( value, currentMaterial );
                },
              }}
            />
          </div>
        </div>
      </List.Item>

      <Divider />

      {/* Offset */}
      <List.Item>
        <div className="row">
          <div className="column materialNameColumn">
            <label className="materialName">Offset: </label>
          </div>

          <div className="column" style={{ width: "120px" }}>
            <Slider
              color="blue"
              style={{
                trackFill: { backgroundColor: "#3498db" },
              }}
              inverted={false}
              value={offsetX}
              settings={{
                max: 1,
                step: 0.01,
                min: 0,
                onChange: ( value ) => {
                  changeOffsetX( value, currentMaterial.map );
                },
              }}
            />
          </div>

          <div className="column" style={{ width: "120px" }}>
            <Slider
              color="blue"
              style={{
                trackFill: { backgroundColor: "#3498db" },
              }}
              inverted={false}
              value={offsetY}
              settings={{
                max: 1,
                step: 0.01,
                min: 0,
                onChange: ( value ) => {
                  changeOffsetY( value, currentMaterial.map );
                },
              }}
            />
          </div>
        </div>
      </List.Item>
      <List.Item>
        <Button  
        style={{ margin: 5, float: "left", backgroundColor: "gold", color: "black" }}

        onClick={loadAllFiles}>
          Hepsini indir
        </Button>
      </List.Item>
    </AccordionItem>
  );
}
export default MaterialAccordionItem;
